@if (!parentId) {
  <div>{{ 'entities.auscultationInformation.messages.assetUnavailable' | transloco }}</div>
}

@if (parentId) {
  <form [formGroup]="auscultationForm">
    <div class="mb-(--space-4) max-w-80">
      <ces-text-field
        class="w-full"
        formControlName="name"
        [label]="'common.labels.name' | transloco"
        [required]="true"
        [minLength]="3"
        [maxLength]="50"
        [unicityArray]="existingNamesOnAsset()"
        unicityKey="name"
        [unicityExcludeValue]="isEditMode() ? entity?.name : undefined" />
    </div>

    <div class="mb-(--space-4) max-w-80">
      <ces-select-field
        class="w-full"
        formControlName="type"
        [options]="typeOptions"
        [required]="true"
        [label]="'common.labels.dataType' | transloco"
        [placeholder]="'common.placeholders.selectDataType' | transloco" />
    </div>

    @if (shouldShowChoiceList()) {
      <div class="mb-(--space-4) max-w-80">
        <ces-select-field
          class="w-full"
          formControlName="choiceListId"
          [required]="true"
          [label]="'entities.choiceList.singular' | transloco"
          optionsStore="ChoiceList" />
      </div>
    }

    <div class="mb-(--space-4) max-w-196">
      <ces-select-field
        class="w-full"
        [multiSelect]="true"
        [optionsFilter]="{ property: 'assetId', value: this.parentId, operator: 'equals' }"
        [storeLoadParams]="[parentId]"
        formControlName="locationIds"
        [label]="'common.labels.locations' | transloco"
        optionsStore="Location"
        storeLoadMethod="getLocationsByAsset" />
    </div>

    <div class="mb-(--space-4) max-w-196">
      <ces-text-field
        class="w-full"
        type="textarea"
        [rows]="5"
        formControlName="description"
        [label]="'common.labels.description' | transloco" />
    </div>

    <ces-dialog-footer
      [submitDisabled]="auscultationForm.invalid || submitting"
      (onCancel)="onFormCancel()"
      (onSubmit)="submitForm()" />

    <ces-form-debug-panel [form]="auscultationForm" />
  </form>
}
